import { useState, useRef, useEffect } from 'react';
import { Slider, Button, Upload, message } from 'antd';
import { forwardRef } from 'react'
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import styles from './index.module.scss'
import { RELIGHT_MODE, HOME_PAGE_TYPE, IMAGE_TYPE, UPLOAD_SOURCE } from "@utils/CONST"
import Utils from '@utils/utils';
import PSAIModal from '@PSAIComponents/PSAIModal';
import { UploadOutlined } from '@ant-design/icons';


const FillLightBar = forwardRef((props, ref) => {
    const { AIEditLoading } = useContext(AIEditContext)

    const isMounted = useRef(true)

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    //  const status = Utils.checkLoginStatus(() => selectPreset(index, style))
    //     if (!status) return

    const [strength, setStrength] = useState(1.0)
    const [relightMode, setRelightMode] = useState(RELIGHT_MODE.SKIN)
    const [refImgUrl, setRefImgUrl] = useState(null)
    const imgMaxLimit = useRef(4096)

    const beforeUpload = async (file) => {
        try {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp' || file.type === 'image/avif';
            if (!isJpgOrPng) throw new Error('您只能上传JPG/PNG/WEBP/AVIF格式的文件')
            const { width, height } = await Utils.getImageDimensions(file)
            if ((width > imgMaxLimit.current || height > imgMaxLimit.current)) {
                PSAIModal.confirm({
                    title: '图片过大',
                    content: `为您调整尺寸后可打开, 分辨率 ≤ ${imgMaxLimit.current}*${imgMaxLimit.current}`,
                    okText: '调整并打开',
                    cancelText: '重新上传',
                    onOk: async () => {
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, imgMaxLimit.current)
                        if (resizeRes && resizeRes.success) {
                            beforeUpload(resizeRes.file)
                        } else {
                            message.warning(resizeRes.message)
                        }
                    },
                    onCancel: async () => {
                    }
                })
            } else {
                if (file) {
                    const res = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.AIEDIT_MODEL)
                    if (!res) return false
                    if (!res.isLegal) {
                        PSAIModal.confirm({
                            content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                            okText: '继续上传',
                            cancelText: '取消',
                            onOk() { },
                            onCancel() { },
                        })
                        return false
                    }
                    setRefImgUrl(res.data)
                }
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            return false
        }
    }

    const modeList = [
        { label: '标准', value: RELIGHT_MODE.SKIN },
        { label: '人像', value: RELIGHT_MODE.PORTRAIT },
        { label: '反光板', value: RELIGHT_MODE.REFLECTOR },
        // { label: '参考图光影', value: RELIGHT_MODE.REF },
    ]

    const canCreate = Boolean(props.url) && !(relightMode === RELIGHT_MODE.REF && !refImgUrl)

    const createClick = async () => {
        if (!canCreate) return
        const status = Utils.checkLoginStatus(() => createClick())
        if (!status) return

        props.createClick({ strength, relightMode, refImgUrl })
    }

    return (
        <div className={styles.FillLight}>
            <div className={`${styles.FillLightContent} ${!props.url && styles.disabled}`}>
                <div className={styles.modeButtons}>
                    {modeList.map(item => (
                        <span
                            key={item.value}
                            className={`${styles.modeBtn} ${relightMode === item.value ? styles.active : ''}`}
                            onClick={() => {
                                setRelightMode(item.value)
                                if (item.value !== RELIGHT_MODE.REF) {
                                    setRefImgUrl(null)
                                }
                            }}
                        >
                            {item.label}
                        </span>
                    ))}
                </div>

                {relightMode === RELIGHT_MODE.REF ? (
                    <Upload.Dragger
                        accept='image/jpeg,image/png,image/webp,image/avif'
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        className={styles.uploadDragger}
                    >
                        <div className={styles.uploadArea}>
                            {refImgUrl ? (
                                <>
                                    <img src={refImgUrl} className={styles.previewImg} alt="Reference" />
                                    <div className={styles.reuploadMask}>
                                        <div className={styles.reuploadBtn}>
                                            <UploadOutlined />
                                            <span>重新上传</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.uploadText}>请上传光影参考图</div>
                                    <div className={styles.uploadSubText}>点击 或 将图片拖拽至此区域</div>
                                </>
                            )}
                        </div>
                    </Upload.Dragger>
                ) : (
                    <div className={styles.sliderRow}>
                        <div className={styles.sliderLabelRow}>
                            <span>更像原图</span>
                            <span>更加自然</span>
                        </div>
                        <Slider
                            min={0.8}
                            max={1.4}
                            step={0.1}
                            value={strength}
                            onChange={setStrength}
                        />
                    </div>
                )}

                <Button
                    type="primary"
                    loading={AIEditLoading}
                    disabled={!canCreate}
                    className={styles.createBtn}
                    onClick={createClick}>
                    应用改动
                    <img src={require('@assets/images/arcbean3.png')} />
                    <span className={styles.beanNum}>5</span>
                </Button>
            </div>
        </div>
    )
})

export default FillLightBar;
